<template>
  <div>
    <el-card>
      <p>
        <el-button
          size="mini"
          style="width: 90px; margin: 0 0 10px 10px"
          type="primary"
          @click="add"
          >添加</el-button
        >
      </p>
      <viewer :images="photo">
        <p style="margin-left:10px">({{this.coverImgSize}})</p>
        <img
          v-for="(src, index) in photo"
          :src="src"
          :key="index"
          style="width: 100px; height: auto; float: left; margin: 0 0 20px 10px"
        />
      </viewer>
      <!-- <img :src="content.locationImg" alt="" /> -->
    </el-card>
    <el-card style="margin-top: 20px">
      <el-table
        :data="list"
        :header-cell-style="getRowClass"
        border
        ref="multipleTable"
        style="width: 100%; flex: auto"
        tooltip-effect="light"
      >
        <el-table-column prop="type" label="类型" align="center" width="120px">
          <template slot-scope="{ row }">
            <span v-if="row.contentType == 1">新闻</span>
            <span v-if="row.contentType == 4">音频</span>
            <span v-if="row.contentType == 5">视频</span>
            <span v-if="row.contentType == 6">专题</span>
            <span v-if="row.contentType == 8">新闻留言</span>
            <span v-if="row.contentType == 9">投票</span>
            <span v-if="row.contentType == 10">问卷</span>
            <span v-if="row.contentType == 11">召集令</span>
            <span v-if="row.contentType == 12">新房</span>
            <span v-if="row.contentType == 13">二手房</span>
            <span v-if="row.contentType == 14">广告</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="title"
          label="标题"
          align="center"
          width="400"
        ></el-table-column>
        <el-table-column
          prop="coverImg"
          label="封面图"
          align="center"
          width="300"
        >
          <template slot-scope="{ row }">
            <viewer :images="photo1">
              <img
                :src="row.coverImg"
                :key="row.id"
                style="width: auto; height: 50px"
              />
            </viewer>
          </template>
        </el-table-column>
        <el-table-column
          prop="rank"
          label="轮播位置"
          align="center"
          width="100"
        >
          <template slot-scope="{ row }">
            <span v-if="row.rank == 1">第一轮播位</span>
            <span v-if="row.rank == 2">第二轮播位</span>
            <span v-if="row.rank == 3">第三轮播位</span>
            <span v-if="row.rank == 4">第四轮播位</span>
            <span v-if="row.rank == 5">第五轮播位</span>
            <span v-if="row.rank == 6">第六轮播位</span>
            <span v-if="row.rank == 7">第七轮播位</span>
            <span v-if="row.rank == 8">第八轮播位</span>
            <span v-if="row.rank == 9">第九轮播位</span>
            <span v-if="row.rank == 10">第十轮播位</span>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          class-name="small-padding fixed-width"
          label="操作"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <div class="done">
              <el-button
                size="mini"
                style="width: 90px; margin: 0 0 10px 10px"
                type="primary"
                @click="changeList(row)"
                >修改</el-button
              >
              <el-button
                size="mini"
                style="width: 90px; margin: 0 0 10px 10px"
                type="primary"
                @click="deleteItem(row)"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <!-- 修改弹框 -->
    <a-modal
      v-model="visible"
      title="修改"
      ok-text="确认"
      cancel-text="取消"
      @ok="hideModal"
    >
      <el-form>
        <el-row>
          <el-form-item label="信息流位置 ">
            <el-select placeholder="请选择" v-model="editData.rank" clearable>
              <el-option
                v-for="item in rankItem"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="封面图" prop="coverUrl" ref="coverUrl">
            <el-upload
              class="avatar-uploader"
              :action="serverUrl"
              :headers="header"
              name="img"
              :auto-upload="true"
              :show-file-list="false"
              :on-success="upSuccess"
            >
              <img
                v-if="editData.coverImg"
                :src="editData.coverImg"
                class="avatar"
                style="width: 250px; height: auto"
              />

              <i
                :class="
                  loadUpt
                    ? 'el-icon-loading'
                    : 'el-icon-plus avatar-uploader-icon'
                "
                style="margintop: 10px; font-size: 50px"
                v-else
              ></i>
            </el-upload>
          </el-form-item>
        </el-row>
      </el-form>
    </a-modal>
    <!-- 添加页面 -->
    <a-drawer
      title="添加"
      :width="1300"
      :visible="addvisible"
      :body-style="{ paddingBottom: '80px' }"
      @close="onClose"
    >
      <Add :AddData="addData" />
    </a-drawer>
    <!-- 删除弹出框 -->
    <a-modal
      :visible="delOpen"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <p>确定要删除吗？</p>
    </a-modal>
  </div>
</template>
<script>
import Add from "./add";
import { baseURL } from "../../api/config";
export default {
  components: {
    Add,
  },
  data() {
    return {
      delOpen: false,
      photo: [],
      photo1: [],
      addvisible: false,
      addData: [],
      loadUpt: false,
      content: [],
      list: [],
      pagesize: 10, //每页的个数
      currentPage: 1, //初始页
      totalCount: 0, //分页数量展示
      visible: false,
      editData: [],
      coverImgSize:"",
      serverUrl: baseURL + "/file/uploadFile",
      header: {
        token: localStorage.getItem("key"),
      },
      itemList: [],
      rankItem: [
        {
          value: 1,
          label: "第一轮播位",
        },
        {
          value: 2,
          label: "第二轮播位",
        },
        {
          value: 3,
          label: "第三轮播位",
        },
        {
          value: 4,
          label: "第四轮播位",
        },
        {
          value: 5,
          label: "第五轮播位",
        },
        {
          value: 6,
          label: "第六轮播位",
        },
        {
          value: 7,
          label: "第七轮播位",
        },
        {
          value: 8,
          label: "第八轮播位",
        },
        {
          value: 9,
          label: "第九轮播位",
        },
        {
          value: 10,
          label: "第十轮播位",
        },
      ],
    };
  },
  mounted() {
    this.content = this.$route.query.obj;
    this.itemList = this.$route.query.obj;
    this.photo = [];
    this.coverImgSize=this.$route.query.obj.coverImgSize;
    this.photo.push(this.$route.query.obj.locationImg);
    this.getList();
  },
  methods: {
    onClose() {
      this.addvisible = false;
      this.getList();
    },
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%;text-aligin:center;text-align: center;";
      } else {
        return "";
      }
    },
    // 修改
    changeList(obj) {
      this.visible = true;
      this.editData = obj;
    },
    //不删除：
    handleCancel() {
      this.delOpen = false;
    },
    //确定删除
    handleOk() {
      this.getAxios(`/rotation/delete?id=${this.deleteId}`).then((res) => {
        if (res.success == true) {
          this.getList();
          this.$message.success(res.message);
          this.delOpen = false;
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    deleteItem(row) {
      this.deleteId = row.id;
      this.delOpen = true;
    },
    add() {
      this.addvisible = true;
      this.addData = this.itemList;
    },
    // 封面图上传成功
    upSuccess(file) {
      this.editData.coverImg = file.entity;
    },
    hideModal() {
      this.visible = false;
      this.postAxios("/rotation/update", {
        id: this.editData.id,
        coverImg: this.editData.coverImg,
        rank: this.editData.rank,
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.getList();
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    getList() {
      this.getAxios("/rotation/listByLocation", {
        location: this.content.location,
        areaCode: localStorage.getItem("areaCode"),
      }).then((res) => {
        this.list = res.content;
        this.totalCount = res.totalCount;
        this.list.map((i) => {
          this.photo1.push(i.coverImg);
        });
      });
    },
  },
  watch: {
    "$route.query"(newVal, oldVal) {
      this.content = newVal.obj;
      this.itemList = newVal.obj;
      this.photo = [];
      this.coverImgSize=newVal.obj.coverImgSize;
      this.photo.push(this.$route.query.obj.locationImg);
      this.getList();
    },
  },
};
</script>
<style scoped>
img {
  height: 200px;
}
</style>